import React, { useState } from 'react';
import { Upload, Button, Typography } from 'antd';
import Modal from '../../../../components/reusable/Modal';
import { UploadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setDebtUploadModalVisible } from '../../../../store/entities/administration';
import LoadingSpinner from '../../../../components/reusable/LoadingSpinner';
import { uploadDebts } from '../../../../store/entities/administration/thunks';
import { ReactComponent as Icon } from 'assets/img/icons/cardIcons/contactInfo.svg';
import { BlockHeader } from '../../../../components/reusable/BlockHeader';
import { Trans, useTranslation } from 'react-i18next';

const { Paragraph, Text } = Typography;

const UploadDebtModal = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { isDebtUploadModalVisible } = useSelector(state => state.administration);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleClose = () => {
    dispatch(setDebtUploadModalVisible(false));
  };

  const handleUpload = async () => {
    try {
      const formData = new FormData();
      formData.append('FileDetails', selectedFile);
      setLoading(true);
      dispatch(uploadDebts(formData));
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      secondaryTitle={
        <BlockHeader
          title={t('administration.uploadDebt.modal.title')}
          icon={<Icon style={{ height: 30, width: 30 }} />}
        />
      }
      visible={isDebtUploadModalVisible}
      onCancel={() => dispatch(setDebtUploadModalVisible(false))}
      footer={[
        <Button size="small" key="cancel" onClick={handleClose}>
          {t('global.cancel')}
        </Button>,
        <Button size="small" key="upload" className="save" onClick={handleUpload} disabled={!selectedFile}>
          {t('global.upload')}
        </Button>,
      ]}
      size="md"
      destroyOnClose
      className="new-debt"
    >
      <LoadingSpinner size="small" spinning={loading}>
        <Typography>
          <Paragraph>{t('administration.uploadDebt.modal.text1')}</Paragraph>
          <Paragraph>
            <Text strong>{t('administration.uploadDebt.modal.text2')}</Text>
          </Paragraph>
        </Typography>
        <Upload.Dragger
          name="file"
          multiple={false}
          accept=".xlsx,.xml"
          beforeUpload={file => {
            setSelectedFile(file);
            return false;
          }}
          fileList={selectedFile ? [selectedFile] : []}
          onRemove={() => {
            setSelectedFile(null);
          }}
          style={{ padding: '20px 0' }}
        >
          <p className="ant-upload-drag-icon">
            <UploadOutlined />
          </p>
          <p className="ant-upload-text">{t('administration.uploadDebt.modal.upload1')}</p>
          <p className="ant-upload-hint">
            <Trans i18nKey={'administration.uploadDebt.modal.upload2'} components={{ under: <u /> }} />
          </p>
        </Upload.Dragger>
      </LoadingSpinner>
    </Modal>
  );
};

export default UploadDebtModal;
